import React from 'react';
import { KpiCard, KpiCardProps } from './KpiCard';
import { cn } from '@/lib/utils';

export interface KpiCardGroupProps {
  cards?: KpiCardProps[];
  children?: React.ReactNode;
  columns?: 2 | 3 | 4 | 5;
  className?: string;
}

export const KpiCardGroup: React.FC<KpiCardGroupProps> = ({
  cards,
  children,
  columns = 4,
  className,
}) => {
  const columnClasses = {
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-3',
    4: 'grid-cols-2 lg:grid-cols-4',
    5: 'grid-cols-2 md:grid-cols-3 lg:grid-cols-5',
  }[columns];

  return (
    <div className={cn('grid gap-3.5 sm:gap-4', columnClasses, className)}>
      {cards
        ? cards.map((card, index) => (
            <KpiCard key={card.title || index} {...card} />
          ))
        : children}
    </div>
  );
};
